import { connect } from 'react-redux';

import commonActions from '../../../actions/common';
import { getData, getAndStore } from '../../../actions/utils';
import { updateUser, deleteUser } from '../../../actions/users';
import SettingsUsers from './SettingsUsers';
import usersSchema from '../../../normalizr-schemas/usersSchema';

const usersConfigActions = commonActions('users');

const mapStateToProps = (props) => {
  const {
    users, isNewUserModalOpen, isEditUserModalOpen, isDeleteUserModalOpen,
  } = props;

  return {
    users,
    isNewUserModalOpen,
    isEditUserModalOpen,
    isDeleteUserModalOpen,
  };
};

const mapDispatchToProps = dispatch => ({
  getUsers: () => dispatch(getData('users', 'users', usersSchema, true)),
  loadMore: () => dispatch(getAndStore('users', 'users', usersSchema, true)),
  openNewUserModal: () => dispatch(usersConfigActions.openAddModal()),
  openEditUserModal: id => dispatch(usersConfigActions.openEditModal(id)),
  closeEditUserModal: id => dispatch(usersConfigActions.closeEditModal(id)),
  openDeleteUserModal: id => dispatch(usersConfigActions.openDeleteModal(id)),
  closeDeleteUserModal: id => dispatch(usersConfigActions.closeDeleteModal(id)),
  updateUser: (id, data) => dispatch(updateUser(id, data.role)),
  deleteUser: id => dispatch(deleteUser(id)),
});

const SettingsUsersContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SettingsUsers);

export default SettingsUsersContainer;



// WEBPACK FOOTER //
// ./src/components/Settings/users/SettingsUsersContainer.js